import { Box } from "@mui/material"
import { theme } from "src/providers/ThemeProvider"
import GiftExchangeHistory from "./GifitExchangeHistory"
import GiftExchange from "./GiftExchange"
import TemAccumulation from "./TemAccumulation"

const User = () => {
  return (
    <Box
      padding={theme.spacing(0, 2)}
      width="100%"
      display="flex"
      flexDirection="column"
      rowGap={"90px"}
      position="relative"
      alignItems="center"
    >
      <GiftExchange />
      <GiftExchangeHistory />
      <TemAccumulation />
    </Box>
  )
}

export default User
